module.exports = __webpack_public_path__ + "img/pic_Kaohsiung.6100971d.jpg";